/**
 * User-selectable display currency. Decoupled from locale.
 * Cookie-backed so SSR can pick the right currency on the first render.
 */

import type { Currency } from "./fx";

export type { Currency } from "./fx";

export const CURRENCY_COOKIE = "bpd_currency";
export const CURRENCY_OPTIONS: readonly Currency[] = ["EUR", "USD", "TRY"] as const;

const TR_LOCALE = "tr";
const EUR_LOCALES = new Set(["de", "fr", "es", "it", "sv"]);

/** Default currency if the user hasn't picked one. */
export function defaultCurrencyForLocale(locale: string): Currency {
  if (locale === TR_LOCALE) return "TRY";
  if (EUR_LOCALES.has(locale)) return "EUR";
  return "USD";
}

/** Validate a string read from a cookie — fall back to locale default. */
export function resolveCurrency(raw: string | undefined, locale: string): Currency {
  const upper = (raw ?? "").toUpperCase();
  if ((CURRENCY_OPTIONS as readonly string[]).includes(upper)) return upper as Currency;
  return defaultCurrencyForLocale(locale);
}
